/**
 * The tracks of the Academy on the public page (D-105, D-109, D-118): TCF Canada and TEF Canada
 * (French, NCLC), IELTS General Training (English, bands) and German (Goethe-Zertifikat A1 to C2).
 * Picking one remembers it for after the sign-in; D-160: it is the exam of the sign-up, the only
 * one the learner space then shows (the agency adds another one if needed).
 */

import { Check, Landmark, Languages, Route, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

import { EXAMS, type ExamCode, GOETHE_CODE, IELTS, TEF, useActiveExam } from "./exam";

const TONE: Record<string, string> = { [IELTS]: "success", [TEF]: "warning", [GOETHE_CODE]: "info" };

export function ExamTracks() {
  const { t } = useTranslation();
  const { exam, setExam } = useActiveExam();
  return (
    <section className="ac-tracks" aria-labelledby="ac-tracks-title">
      <h2 id="ac-tracks-title" className="ac-label">
        {t("ielts.tracks.title")}
      </h2>
      <div className="ac-tracks__list" role="radiogroup" aria-labelledby="ac-tracks-title">
        {EXAMS.map((code: ExamCode) => {
          const on = code === exam;
          return (
            <button key={code} type="button" role="radio" aria-checked={on} className={`ac-track ao-pressable${on ? " ac-track--on" : ""}`} onClick={() => setExam(code)}>
              <span className={`ac-pastille ac-tone--${TONE[code] ?? "accent"}`} aria-hidden="true">
                {code === IELTS ? <Route size={16} /> : code === TEF ? <Landmark size={16} /> : code === GOETHE_CODE ? <Sparkles size={16} /> : <Languages size={16} />}
              </span>
              <span className="ac-track__text">
                <span className="ac-track__name">{t(`ielts.exams.${code}.name`)}</span>
                <span className="ac-track__line">{t(`ielts.tracks.${code}`)}</span>
              </span>
              <span className="ac-track__check" aria-hidden="true">
                {on && <Check size={14} strokeWidth={3} />}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
